import { dashboard } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  getAdminDashboardData(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(dashboard.adminDashboardBase, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTransporterDashboardData(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(dashboard.transporterDashboardBase, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getCustomerDashboardData(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(dashboard.customerDashboardBase, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
